import { useAccountDataQuery } from 'queries/account';
export var AddonFeature = /*#__PURE__*/ function(AddonFeature) {
    AddonFeature[AddonFeature["User"] = 1] = "User";
    AddonFeature[AddonFeature["Partners"] = 21] = "Partners";
    AddonFeature[AddonFeature["Rbac"] = 22] = "Rbac";
    AddonFeature[AddonFeature["TimeTrackingUsers"] = 38] = "TimeTrackingUsers";
    AddonFeature[AddonFeature["SupportCosts"] = 39] = "SupportCosts";
    AddonFeature[AddonFeature["LiteUsers"] = 27] = "LiteUsers";
    AddonFeature[AddonFeature["CustomReport"] = 40] = "CustomReport";
    AddonFeature[AddonFeature["SkillMatrix"] = 45] = "SkillMatrix";
    AddonFeature[AddonFeature["ResourceRequest"] = 44] = "ResourceRequest";
    AddonFeature[AddonFeature["Invoice"] = 52] = "Invoice";
    AddonFeature[AddonFeature["InvoiceApprovalChains"] = 53] = "InvoiceApprovalChains";
    AddonFeature[AddonFeature["AdditionalDependencies"] = 54] = "AdditionalDependencies";
    AddonFeature[AddonFeature["Expense"] = 154] = "Expense";
    AddonFeature[AddonFeature["ExpenseApprovalChains"] = 55] = "ExpenseApprovalChains";
    AddonFeature[AddonFeature["MultiBudget"] = 68] = "MultiBudget";
    AddonFeature[AddonFeature["BillingSchedule"] = 80] = "BillingSchedule";
    return AddonFeature;
}({});
const nonRbacAddonAccountIds = [
    12059,
    400
];
export const useAddon = (addonFeature)=>{
    var _accountData_billingMeta_subscription_addons, _accountData_billingMeta_subscription, _accountData_billingMeta;
    const { data: accountData } = useAccountDataQuery();
    const isTheAddonPresent = Boolean(accountData === null || accountData === void 0 ? void 0 : (_accountData_billingMeta = accountData.billingMeta) === null || _accountData_billingMeta === void 0 ? void 0 : (_accountData_billingMeta_subscription = _accountData_billingMeta.subscription) === null || _accountData_billingMeta_subscription === void 0 ? void 0 : (_accountData_billingMeta_subscription_addons = _accountData_billingMeta_subscription.addons) === null || _accountData_billingMeta_subscription_addons === void 0 ? void 0 : _accountData_billingMeta_subscription_addons.find((addon)=>(addon === null || addon === void 0 ? void 0 : addon.addonId) === addonFeature));
    if (addonFeature === 22) {
        var _ref;
        var _accountData_account;
        return isTheAddonPresent || nonRbacAddonAccountIds.includes((_ref = accountData === null || accountData === void 0 ? void 0 : (_accountData_account = accountData.account) === null || _accountData_account === void 0 ? void 0 : _accountData_account.accountId) !== null && _ref !== void 0 ? _ref : -1);
    }
    return isTheAddonPresent;
};
